module.exports = __webpack_public_path__ + "7c2178b51c7545ecca84958c572228cf.png";